// extracted by mini-css-extract-plugin
export default {"root":"styles_root__b0YhF"};